/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Static information to identify a ship. To query a given ship provide any information available. Using more information will enhance the chance for identification.
 * @export
 * @interface Ship
 */
export interface Ship {
    /**
     * 
     * @type {number}
     * @memberof Ship
     */
    mmsi?: number;
    /**
     * 
     * @type {number}
     * @memberof Ship
     */
    imo?: number;
    /**
     * 
     * @type {string}
     * @memberof Ship
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Ship
     */
    callsign?: string;
}

/**
 * Check if a given object implements the Ship interface.
 */
export function instanceOfShip(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipFromJSON(json: any): Ship {
    return ShipFromJSONTyped(json, false);
}

export function ShipFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ship {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'callsign': !exists(json, 'callsign') ? undefined : json['callsign'],
    };
}

export function ShipToJSON(value?: Ship | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mmsi': value.mmsi,
        'imo': value.imo,
        'name': value.name,
        'callsign': value.callsign,
    };
}

